<body class="vertical-layout vertical-menu 2-columns menu-expanded" style="overflow: auto !important">
  <div class="col-xl-12 col-lg-12 container" id="propostaExterna">
    <div class="card card-form">
      <div class="card-content">
        <div class="card-body tabbable">
          <div class="card-block text-center">
            <div *ngIf="tabHabilitada">
              <img
                class="img-geia-top image-main"
                src="../../../../assets/app-assets/images/logo/logo-b-geia.png"
                style="margin-left: 30px; margin-top: 15px; margin-bottom: 9px" />
              <img [src]="logoEntidade" alt="Logo" style="margin-left: 30px; margin-top: 15px; margin-bottom: 9px" />
            </div>
          </div>

          <!-- Abas -->
          <ul class="nav nav-tabs nav-linetriangle" id="sectionAbas" style="border-radius: 0">
            <!-- Beneficiário -->
            <li [style.flex]="tabHabilitada ? '1' : 'unset'" class="nav-item cursor-pointer">
              <a
                #beneficiarioLink
                class="nav-link cursor-pointer"
                [ngClass]="{'active show': activeTab === 'beneficiario'}"
                id="beneficiario"
                (click)="clicarNaAba(propostaEnum.BENEFICIARIO_CONCORDO)"
                data-toggle="tab"
                aria-controls="tabBeneficiario"
                href="#tabBeneficiario"
                aria-expanded="true">
                <i class="fa fa-users icon"></i>
                Beneficiário
              </a>
            </li>
            <!-- Declaração de Saúde -->
            <!-- <li *ngIf="!this.heOdonto" class="nav-item cursor-pointer">
              <a
                tooltipClass="tooltip"
                class="nav-link cursor-pointer"
                id="saude"
                data-toggle="tab"
                aria-controls="tabValidacao"
                href="#tabValidacao"
                aria-expanded="false">
                <i class="fa fa-user-md icon"></i>
                Validacao - Teste
              </a>
            </li> -->
            <li *ngIf="!this.heOdonto" class="nav-item cursor-pointer">
              <a
                [ngClass]="{'active show': activeTab === 'declaracaoSaude'}"
                tooltipClass="tooltip"
                [class.disabled]="!podeAcessarAba(propostaEnum.CARTA_ORIENTACAO)"
                [attr.disabled]="!podeAcessarAba(propostaEnum.CARTA_ORIENTACAO)"
                class="nav-link cursor-pointer"
                id="saude"
                data-toggle="tab"
                (click)="clicarNaAba(propostaEnum.CARTA_ORIENTACAO)"
                aria-controls="tabDeclaracaoSaude"
                href="#tabDeclaracaoSaude"
                aria-expanded="false">
                <i class="fa fa-user-md icon"></i>
                Declaração de Saúde
              </a>
            </li>
            <!-- Documentos -->
            <li class="nav-item cursor-pointer">
              <a
                [ngClass]="{'active show': activeTab === 'documentos'}"
                tooltipClass="tooltip"
                [class.disabled]="!podeAcessarAba(propostaEnum.DOCUMENTO)"
                [attr.disabled]="!podeAcessarAba(propostaEnum.DOCUMENTO)"
                class="nav-link cursor-pointer"
                id="documentos"
                data-toggle="tab"
                (click)="clicarNaAba(propostaEnum.DOCUMENTO)"
                aria-controls="tabDocumentos"
                href="#tabDocumentos"
                aria-expanded="false">
                <i class="ft-file-plus icon"></i>
                Documentos
              </a>
            </li>
            <!-- Análise -->
            <li *ngIf="!heColaborador" class="nav-item cursor-pointer">
              <a
                [ngClass]="{'active show': activeTab === 'analise'}"
                tooltipClass="tooltip"
                (click)="clicarNaAba(propostaEnum.ANALISE)"
                [class.disabled]="!podeAcessarAba(propostaEnum.ANALISE)"
                [attr.disabled]="!podeAcessarAba(propostaEnum.ANALISE)"
                class="nav-link cursor-pointer"
                id="analise"
                data-toggle="tab"
                aria-controls="tabAnalise"
                href="#tabAnalise"
                aria-expanded="false">
                <i class="fa fa-cogs icon"></i>
                Análise
              </a>
            </li>
            <ng-container *ngIf="!this.heMedSenior">
              <li *ngIf="!this.heOdonto" class="nav-item cursor-pointer">
                <a
                  [ngClass]="{'active show': activeTab === 'videoConferencia'}"
                  [class.disabled]="!podeAcessarAba(propostaEnum.VIDEO_CONFERENCIA)"
                  [attr.disabled]="!podeAcessarAba(propostaEnum.VIDEO_CONFERENCIA)"
                  tooltipClass="tooltip"
                  (click)="clicarNaAba(propostaEnum.VIDEO_CONFERENCIA)"
                  class="nav-link cursor-pointer"
                  id="videoConferencia"
                  data-toggle="tab"
                  aria-controls="tabvideoConferencia"
                  href="#tabvideoConferencia"
                  aria-expanded="false">
                  <i class="fa fa-video-camera icon"></i>
                  Agenda / Videoconferência
                </a>
              </li>
            </ng-container>
            <!-- Pagamento -->
            <li class="nav-item cursor-pointer">
              <a
                [ngClass]="{'active show': activeTab === 'pagamento'}"
                tooltipClass="tooltip"
                [class.disabled]="!podeAcessarAba(propostaEnum.PAGAMENTO)"
                [attr.disabled]="!podeAcessarAba(propostaEnum.PAGAMENTO)"
                (click)="clicarNaAba(propostaEnum.PAGAMENTO)"
                class="nav-link cursor-pointer"
                id="pagamento"
                data-toggle="tab"
                aria-controls="tabPagamento"
                href="#tabPagamento"
                aria-expanded="false">
                <i class="fa fa-money icon"></i>
                Pagamento
              </a>
            </li>
            <!-- Conclusão -->
            <li *ngIf="!heColaborador" class="nav-item cursor-pointer">
              <a
                [ngClass]="{'active show': activeTab === 'conclusao'}"
                tooltipClass="tooltip"
                (click)="clicarNaAba(propostaEnum.CONCLUSAO)"
                [class.disabled]="!podeAcessarAba(propostaEnum.CONCLUSAO)"
                [attr.disabled]="!podeAcessarAba(propostaEnum.CONCLUSAO)"
                class="nav-link cursor-pointer"
                id="conclusao"
                data-toggle="tab"
                aria-controls="tabConclusao"
                href="#tabConclusao"
                aria-expanded="false">
                <i class="fa fa-handshake-o icon"></i>
                Conclusão
              </a>
            </li>
          </ul>
          <!-- Componentes -->
          <div class="tab-content px-1 pt-1">
            <!-- Beneficiário -->
            <div
              [ngClass]="{'active show': activeTab === 'beneficiario'}"
              role="tabpanel"
              class="tab-pane"
              id="tabBeneficiario"
              aria-labelledby="tabBeneficiario"
              aria-expanded="true">
              <app-proposta-associado-entidade-beneficiario
                [heColaborador]="heColaborador"
                [somenteLeituraStep]="ehSomenteLeituraGeral"
                (proximaAba)="navegarParaProximaAba()"></app-proposta-associado-entidade-beneficiario>
            </div>

            <!-- Declaração de Saúde -->
            <div
              *ngIf="!this.heOdonto"
              class="tab-pane"
              id="tabDeclaracaoSaude"
              [ngClass]="{'active show': activeTab === 'declaracaoSaude'}"
              aria-labelledby="tabDeclaracaoSaude">
              <app-proposta-associado-entidade-ds
                *ngIf="activeTab === 'declaracaoSaude'"
                [somenteLeituraStep]="ehSomenteLeituraGeral"
                (proximaAba)="navegarParaProximaAba()"></app-proposta-associado-entidade-ds>
            </div>
            <!-- Documentos -->
            <div
              class="tab-pane"
              [ngClass]="{'active show': activeTab === 'documentos'}"
              id="tabDocumentos"
              aria-labelledby="tabDocumentos">
              <app-proposta-entidade-documentos
                *ngIf="activeTab === 'documentos'"
                [somenteLeituraStep]="ehSomenteLeituraGeral"
                (proximaAba)="navegarParaProximaAba()"></app-proposta-entidade-documentos>
            </div>
            <!--Análise -->
            <div
              *ngIf="!heColaborador"
              class="tab-pane"
              [ngClass]="{'active show': activeTab === 'analise'}"
              id="tabAnalise"
              aria-labelledby="tabAnalise">
              <app-status-processing
                *ngIf="ehSomenteLeituraGeral"
                titulo="Análise da documentação aprovada!"
                subtitulo="Prossiga para o passo seguinte."></app-status-processing>
              <app-status-processing
                *ngIf="!ehSomenteLeituraGeral"
                titulo="Análise da documentação em andamento!"
                subtitulo="Aguarde, em breve entraremos em contato."></app-status-processing>
            </div>
            <ng-container *ngIf="!this.heMedSenior">
              <div
                *ngIf="!this.heOdonto"
                class="tab-pane"
                [ngClass]="{'active show': activeTab === 'videoConferencia'}"
                id="tabvideoConferencia"
                aria-labelledby="tabvideoConferencia">
                <div class="card-body">
                  <app-proposta-entidade-videoconferencia
                    *ngIf="activeTab === 'videoConferencia'"></app-proposta-entidade-videoconferencia>
                </div>
              </div>
            </ng-container>
            <!-- Pagamento -->
            <div
              class="tab-pane"
              id="tabPagamento"
              [ngClass]="{'active show': activeTab === 'pagamento'}"
              aria-labelledby="tabPagamento">
              <!-- Mensagem de Aguarde -->
              <app-status-processing
                *ngIf="isAnalisePagamento"
                titulo="Pagamento enviado!"
                subtitulo="Aguarde a análise do pagamento."></app-status-processing>
              <!-- Conteúdo normal do componente -->
              <div *ngIf="!isAnalisePagamento" class="seu-conteudo-atual">
                <app-proposta-pagamento
                  [isAnalisePagamento]="isAnalisePagamento"
                  (isAnalisePagamentoChange)="onAnalisePagamentoChange($event)"
                  *ngIf="activeTab === 'pagamento'"
                  (proximaAba)="navegarParaProximaAba()"></app-proposta-pagamento>
              </div>
            </div>
            <!-- Conclusão -->
            <div
              class="tab-pane"
              id="tabConclusao"
              [ngClass]="{'active show': activeTab === 'conclusao'}"
              aria-labelledby="tabConclusao">
              <div class="payment-processing-card">
                <div class="payment-processing-content">
                  <div class="proposal-finish">
                    <i class="fa fa-check"></i>
                  </div>
                  <h4 class="payment-processing-title mb-1 text-center">
                    <strong>Proposta Finalizada!</strong>
                  </h4>
                  <h3 class="payment-processing-title">Sua proposta foi concluida com sucesso!</h3>
                  <p class="payment-processing-message">..</p>
                  <div class="progress-container">
                    <div class="progress-bar">
                      <div class="progress-fill"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <ng-container *ngIf="heColaborador">
      <div *ngIf="listaHistoricoProposta.length > 0" class="card card-form">
        <div class="card-content">
          <div class="card-body tabbable">
            <div>
              <app-visualizar-logs-proposta
                [listaHistoricoProposta]="listaHistoricoProposta"></app-visualizar-logs-proposta>
            </div>
          </div>
        </div>
      </div>
    </ng-container>
  </div>
</body>

<div
  *ngIf="mostrarModalRefreshToken"
  class="modal-refresh-token-overlay d-flex justify-content-center align-items-center">
  <div class="text-center-modal">
    <div class="d-flex align-items-center">
      <div class="caixa-texto-modal">
        <h1 class="text-center text-bold-600 mt-1 mb-2">Token Expirado!</h1>
        <p class="typing-text preto-geia mt-2 mb-2">Deseja revalidar o token por mais 1 hora.</p>
        <div class="text-center">
          <button
            (click)="atualizarToken()"
            class="btn cursor-pointer btn-round btn-success-geia white min-width-btn box-shadow-4 mr-1 mb-1">
            <b>Revalidar Token</b>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
